module.exports = __webpack_public_path__ + "img/128.06cb130b.jpg";